var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _vm._v(
          " 该红包池关联的提现费用按照以下设置的税率点进行基础服务费的计算 "
        ),
      ]),
      _c("el-input-number", {
        attrs: { disabled: _vm.disabled, min: 0 },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.num,
          callback: function ($$v) {
            _vm.num = $$v
          },
          expression: "num",
        },
      }),
      _vm._v(" % "),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }